import React, { FC } from 'react';

import { Filter, FilterProps, TextInput } from 'react-admin';

export const AddressFilter: FC<Omit<FilterProps, 'children'>> = props => (
  <Filter {...props}>
    <TextInput label="Name" source="name" />
  </Filter>
);
